<div *transloco="let t" class="container">
  <!--<h1>{{t('help.title')}}</h1>-->

  @if (data.ragsoc) {
    <div class="text-center">
      <p class="text-bold mb-2"><b>{{ data.ragsoc }}</b></p>
      <p class="text-bold mb-0"><b>P.IVA:</b> {{ data.piva }}</p>
    </div>
  }

  <h2>{{ t('share-app') }}</h2>

  <div class="mt-3 text-center">
    @if (qrCode) {
      <img [src]="qrCode" alt="QrCode" draggable="false">
    }
  </div>

  <h2>{{ t('faq') }}</h2>
  <p-accordion ngSkipHydration [value]="['0']">
    <p-accordion-panel value="0">
      <p-accordion-header>{{ t('help.telegram_faq_title') }}</p-accordion-header>
      <p-accordion-content>
        <p [innerHTML]="t('help.telegram_faq_text')"></p>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="1">
      <p-accordion-header>{{ t('help.privacy_tos_title') }}</p-accordion-header>
      <p-accordion-content>
        <p
          [innerHTML]="t('help.privacy_tos_text', {link_privacy_policy: config?.link_privacy_policy, link_terms_condition: config?.link_terms_condition})">
        </p>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="2">
      <p-accordion-header>{{ t('help.cookies') }}</p-accordion-header>
      <p-accordion-content>
        <div [innerHTML]="t('help.cookies_text')"></div>
      </p-accordion-content>
    </p-accordion-panel>
    <p-accordion-panel value="3">
      <p-accordion-header>{{ t('help.samsung_browser_title') }}</p-accordion-header>
      <p-accordion-content>
        <p [innerHTML]="t('help.samsung_browser_text')"></p>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>

  <h2 class="mt-3">{{t('help.support')}}</h2>
  <p class="mb-0">{{ t('help.support_text') }}</p>
  @if (error) {
    <p-message severity="error" [text]="error" [closable]="false"></p-message>
  }
  @if (success && !error) {
    <p-message severity="success" [text]="t('help.request_sent')" [closable]="false"></p-message>
  }
  <form #form="ngForm" novalidate>
    <div class="mt-2">
      <div class="mt-1 w-100">
        <label class="font-semibold" for="email">{{ t('form.email') }}</label>
        <input #email="ngModel" id="email" class="p-inputtext-sm w-full mt-2" placeholder="mario.rossi@gmail.com"
          type="text" name="email" pInputText autocomplete="email" [(ngModel)]="supportModel.email"
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" required />
        <div [hidden]="(email.valid || email.pristine)" class="mt-1"><span class="text-red-500">{{
            t('form.invalid_format') }}</span>
        </div>
      </div>
      <div class="mt-3">
        <label class="font-semibold" for="message">{{t('form.message')}}</label>
        <textarea #message="ngModel" id="message" class="p-inputtext-sm w-full mt-2" type="text" name="message"
          pInputTextarea [(ngModel)]="supportModel.message" minlength="15" required></textarea>
        <div [hidden]="(message.valid || message.pristine)" class="mt-1"><span
            class="text-red-500">{{t('form.field_required')}}</span></div>
      </div>
      <p class="mt-2"
        [innerHTML]="t('form.privacy_tos', {link_cookie_policy: config?.link_privacy_policy, link_terms_condition: config?.link_terms_condition})">
      </p>
      <div class="flex flex-row justify-content-start	align-items-center mt-2">
        <p-button type="submit" [label]="t('form.send_message')" [disabled]="!form.valid"
          [attr.aria-disabled]="!form.valid" [loading]="loading" (onClick)="supportClick($event)"></p-button>
      </div>
    </div>
  </form>

  @if (version != undefined) {
    <p-divider></p-divider>
    <div class="text-center">
      <p>v{{ version }}</p>
    </div>
  }
</div>